<template>
    <be-card flat :title="title" :subtitle="subtitle">
        <div class="row" v-if="view === 'pie'">
            <div class="col col-lg-5">
                <pie-chart :stats="rows" v-if="stats"/>
            </div>
            <div class="col">
                <data-table border :title="title" :title-color="titleColor" :rows="rows"/>
            </div>
        </div>
        <template v-else>
            <bar-chart :stats="rows" :color="chartColor" v-if="stats" class="mb-2"/>
            <data-table :title="title" :title-color="titleColor" :rows="rows"/>
        </template>
    </be-card>
</template>

<script>
    import CheckOptions from '../../../data/CheckOptions';

    import PieChart from './PieChart';
    import BarChart from './BarChart';
    import DataTable from './DataTable';

    export default {
        components: { DataTable, BarChart, PieChart },

        props: {
            title: String,
            subtitle: String,
            optionsKey: String,
            titleColor: String,
            chartColor: String,
            stats: Object,
            view: String,
        },

        data: () => ({
            options: null,
        }),

        computed: {
            optionsForKey() {
                if (!this.options) {
                    return [];
                }

                return this.options
                    .filter(option => this.stats[option.id] !== undefined);
            },

            rows() {
                if (!this.total || !this.options || !this.stats) {
                    return [];
                }

                return this.optionsForKey
                    .map(option => Object.assign({}, option, { result: this.stats[option.id], total: this.total }));
            },

            total() {
                if (!this.stats || !this.optionsForKey) {
                    return 0;
                }

                return Object.values(this.optionsForKey)
                    .reduce((sum, option) => (sum + this.stats[option.id]), 0);
            },
        },

        watch: {
            async optionsKey() {
                this.options = await CheckOptions.getForKey(this.optionsKey);
            },
        },

        async mounted() {
            this.options = await CheckOptions.getForKey(this.optionsKey);
        },
    };
</script>
